import { useState, type FormEvent } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { SimulationInput } from "../../lib/types";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  input: SimulationInput;
}

export function SaveModal({ open, onOpenChange, input }: Props) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      toast.error("Email invalide");
      return;
    }
    setSubmitting(true);
    // TODO: POST /api/save-simulation { email, state: input }
    try {
      window.localStorage.setItem(
        "rentalmnp:simulation:draft",
        JSON.stringify({ email, state: input, savedAt: Date.now() })
      );
    } catch {
      /* ignore */
    }
    setTimeout(() => {
      setSubmitting(false);
      toast.success("Email envoyé !", { duration: 2000 });
      onOpenChange(false);
      setEmail("");
    }, 400);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Ne perdez pas votre simulation</DialogTitle>
          <DialogDescription>
            Recevez un lien par email pour reprendre où vous en êtes.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="vous@exemple.fr"
            className="block w-full rounded-lg border border-input bg-background px-3 py-2.5 text-base text-foreground shadow-sm outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/30"
          />
          <p className="text-xs text-muted-foreground">
            Aucun spam. Désabonnement en 1 clic.
          </p>
          <DialogFooter>
            <button
              type="submit"
              disabled={submitting}
              className="inline-flex w-full items-center justify-center rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm transition hover:bg-primary-dark disabled:opacity-60"
            >
              {submitting ? "Envoi…" : "Recevoir le lien"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
